// import React, { useState } from 'react';
// import { Check } from 'lucide-react';

// const Packages = () => {
//   const [activeTab, setActiveTab] = useState('premium');

//   // Define packages data with Stripe checkout links
//   const packages = [
//     {
//       id: 'platinum',
//       name: 'Platinum Membership',
//       price: 297,
//       popular: true,
//       type: 'premium',
//       stripeUrl: 'https://checkout.stripe.com/c/pay/prctbl_1QOrjHEgC6ZcCDYvNApJFOgr/prctblitm_SOgWhGtT9ppsc0',
//       image: '/platinum.avif',
//       description: 'This all-encompassing program provides fully customized fitness and nutrition plans, priority coaching, and enhanced tracking tools to guide you toward your most ambitious goals. Experience premium support, tailored entirely to your needs.',
//       features: [
//         'Individualized Training Plan UNLIMITED Days/Week - $1400/month Value',
//         'Full Access to Fitness App - $40/Month Value',
//         'UNLIMITED Text Support and Habit + Accountability Coaching - $400/Month Value',
//         'UNLIMITED Nutrition Coaching - $350/Month Value',
//         'Bi-weekly Virtual Check-ins - $300/Month Value',
//         'Mobility Assessment - $200 Value per Session',
//         'Injury/Rehab Consults - $150 Value per Session'
//       ]
//     },
//     {
//       id: 'gold',
//       name: 'Gold Membership',
//       price: 147,
//       popular: false,
//       type: 'premium',
//       stripeUrl: 'https://checkout.stripe.com/c/pay/prctbl_1QOrjHEgC6ZcCDYvNApJFOgr/prctblitm_SOgWhGtT9ppsc1',
//       image: '/gold.avif',
//       description: 'Take your fitness to the next level with the Gold Tier. Designed for those ready to commit, this plan combines personalization with accountability to ensure sustainable progress. With customized programs and ongoing support, you\'ll have the tools to achieve measurable results.',
//       features: [
//         'Individualized Training Plan 3-6 Days/Week - $1200/month Value',
//         'Full Access to Fitness App - $40/Month Value',
//         'Text Support + Accountability Coaching - $400/Month Value',
//         'Nutritional Guidance - $150/Month Value',
//         'Monthly Virtual Check-ins - $150/Month Value'
//       ]
//     },
//     {
//       id: 'silver',
//       name: 'Silver Membership',
//       price: 50,
//       popular: false,
//       type: 'basic',
//       stripeUrl: 'https://checkout.stripe.com/c/pay/prctbl_1QOrjHEgC6ZcCDYvNApJFOgr/prctblitm_SOgWhGtT9ppsc2',
//       image: '/silver.avif',
//       description: 'Start your journey with a solid foundation. The Silver Tier offers essential tools and guidance to help you achieve your fitness goals with structure and flexibility. Ideal for beginners or those looking for general guidance.',
//       features: [
//         'Individualized Training Plan 2-4 Days/Week - $800/month Value',
//         'Full Access to Fitness App - $40/Month Value',
//         'Text Support + Accountability Coaching - $400/Month Value'
//       ]
//     },
//     {
//       id: 'vip',
//       name: 'VIP Membership',
//       price: 'Custom',
//       popular: false,
//       type: 'elite',
//       stripeUrl: '#contact',
//       image: '/vip.avif',
//       description: 'Experience fitness at its most exclusive with the VIP Tier. This coaching experience is tailored to high-achievers seeking unmatched personalization and results. As a VIP member, you\'ll enjoy a fully immersive journey with concierge-level support, elite coaching, hybrid IN PERSON and ONLINE Training Plan along with all of the benefits of the Platinum Tier. **In-person coaching, currently limited to certain regions. Contact us for more details.',
//       features: [
//         'All Platinum Tier Benefits',
//         'In-Person Training Sessions',
//         'Priority Scheduling',
//         'Direct Access to Dr. Olu',
//         'Customized Recovery Protocols',
//         'Quarterly In-Depth Assessments',
//         'VIP Exclusive Resources'
//       ],
//       contactOnly: true
//     },
//   ];

//   // Filter packages based on active tab
//   const filteredPackages = activeTab === 'all' 
//     ? packages 
//     : packages.filter(pkg => pkg.type === activeTab);

//   const handleCheckout = (stripeUrl) => {
//     if (stripeUrl.startsWith('https://checkout.stripe.com')) {
//       window.location.href = stripeUrl;
//     } else if (stripeUrl.startsWith('#')) {
//       const element = document.querySelector(stripeUrl);
//       if (element) {
//         element.scrollIntoView({ behavior: 'smooth' });
//       }
//     } else {
//       window.location.href = stripeUrl;
//     }
//   };

//   return (
//     <section className="py-16 bg-white" id="packages">
      
      
      
//       <div className="max-w-6xl mx-auto px-4">
//         <div className="text-center mb-16">
//           <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
//             Our <span className="text-sky-600">Membership</span> Plans
//           </h2>
//           <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//             Choose the perfect program for your fitness journey
//           </p>
//         </div>

     
//         <div className="flex justify-center mb-12">
//           <div className="inline-flex bg-gray-100 rounded-lg p-1">
//             <button
//               className={`px-4 py-2 rounded-md ${activeTab === 'premium' ? 'bg-sky-600 text-white' : 'text-gray-700 hover:text-sky-600'}`}
//               onClick={() => setActiveTab('premium')}
//             >
//               Premium
//             </button>
//             <button
//               className={`px-4 py-2 rounded-md ${activeTab === 'basic' ? 'bg-sky-600 text-white' : 'text-gray-700 hover:text-sky-600'}`}
//               onClick={() => setActiveTab('basic')}
//             >
//               Basic
//             </button>
//             <button
//               className={`px-4 py-2 rounded-md ${activeTab === 'elite' ? 'bg-sky-600 text-white' : 'text-gray-700 hover:text-sky-600'}`}
//               onClick={() => setActiveTab('elite')}
//             >
//               Elite
//             </button>
//             <button
//               className={`px-4 py-2 rounded-md ${activeTab === 'all' ? 'bg-sky-600 text-white' : 'text-gray-700 hover:text-sky-600'}`}
//               onClick={() => setActiveTab('all')}
//             >
//               All Plans
//             </button>
//           </div>
//         </div>

       
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
//           {filteredPackages.map((pkg) => (
//             <div 
//               key={pkg.id} 
//               id={pkg.id === 'platinum' ? 'pricing-platinum' : undefined}
//               className={`relative rounded-2xl overflow-hidden transition-all duration-300 hover:shadow-xl ${
//                 pkg.popular ? 'border-2 border-yellow-400 shadow-lg' : 'border border-gray-200 shadow-sm'
//               }`}
//             >
//               {pkg.popular && (
//                 <div className="absolute top-0 left-0 right-0 bg-yellow-400 text-center py-1 text-sm font-bold">
//                   Most popular
//                 </div>
//               )}
              
//               <div className={`p-6 ${pkg.popular ? 'pt-8' : ''} flex flex-col h-full`}>
//                 <div className="flex items-center gap-4 mb-4">
//                   <img 
//                     src={pkg.image} 
//                     alt={pkg.name}
//                     className="h-16 w-auto object-contain"
//                     onError={(e) => {
//                       e.target.onerror = null;
//                       e.target.src = "/api/placeholder/150/75?text=" + pkg.name;
//                     }}
//                   />
//                   <div>
//                     <h3 className="text-2xl font-bold">{pkg.name}</h3>
//                     <div className="flex items-end">
//                       {typeof pkg.price === 'number' ? (
//                         <>
//                           <span className="text-3xl font-bold">${pkg.price}</span>
//                           <span className="text-gray-500 ml-2">per month</span>
//                           {pkg.id === 'platinum' && (
//                             <span className="text-green-600 ml-2 text-sm font-medium">+ 7 days free trial</span>
//                           )}
//                         </>
//                       ) : (
//                         <span className="text-2xl font-bold text-sky-600">{pkg.price}</span>
//                       )}
//                     </div>
//                   </div>
//                 </div>

//                 <div className="flex gap-6">
//                   <div className="flex-1">
//                     <p className="text-gray-600 mb-4">
//                       {pkg.description}
//                     </p>
                    
//                     <button
//                       onClick={() => handleCheckout(pkg.stripeUrl)}
//                       className={`w-full text-center py-2 px-6 rounded-xl font-medium ${
//                         pkg.contactOnly 
//                           ? 'bg-white border-2 border-sky-600 text-sky-600 hover:bg-sky-50' 
//                           : pkg.id === 'platinum'
//                             ? 'bg-green-600 text-white hover:bg-green-700'
//                             : 'bg-sky-600 text-white hover:bg-sky-700'
//                       }`}
//                     >
//                       {pkg.contactOnly 
//                         ? 'Contact us' 
//                         : pkg.id === 'platinum'
//                           ? 'Start Free Trial'
//                           : 'Subscribe'
//                       }
//                     </button>
//                   </div>

//                   <div className="flex-1">
//                     <h4 className="font-bold mb-2">This includes:</h4>
//                     <ul className="space-y-1">
//                       {pkg.features.map((feature, index) => (
//                         <li key={index} className="flex items-start gap-2">
//                           <span className="flex-shrink-0 mt-1 text-sky-600">
//                             <Check size={16} />
//                           </span>
//                           <span className="text-gray-700 text-sm">{feature}</span>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         <div className="mt-12 text-center">
//           <p className="text-gray-500 mb-4">
//             All plans include a 7-day satisfaction guarantee. Not sure which plan is right for you?
//           </p>
//           <a
//             href="#pricing"
//             className="inline-block bg-sky-600 text-white px-8 py-3 rounded-xl hover:bg-sky-700 transition"
//           >
//             Schedule a Free Consultation
//           </a>
//         </div>
//       </div>


//     </section>
//   );
// };

// export default Packages;



// //v2

// import React, { useState, useEffect } from 'react';
// import { Check } from 'lucide-react';

// const Packages = () => {
//   const [activeTab, setActiveTab] = useState('premium');
//   const [stripe, setStripe] = useState(null);
//   const [loading, setLoading] = useState({});

//   // Initialize Stripe
//   useEffect(() => {
//     const initializeStripe = async () => {
//       if (window.Stripe) {
//         const stripeInstance = window.Stripe('pk_live_51QOqT3EgC6ZcCDYvAN6nE9DgoBXhbzWj6U6ASsg8hJt9bm3sQNehA2suTPxqBHZAvdY3e0NBt6e8sQJ913wk14lY00XuM9vN9o');
//         setStripe(stripeInstance);
//       } else {
//         // Load Stripe script if not already loaded
//         const script = document.createElement('script');
//         script.src = 'https://js.stripe.com/v3/';
//         script.async = true;
//         script.onload = () => {
//           const stripeInstance = window.Stripe('pk_live_51QOqT3EgC6ZcCDYvAN6nE9DgoBXhbzWj6U6ASsg8hJt9bm3sQNehA2suTPxqBHZAvdY3e0NBt6e8sQJ913wk14lY00XuM9vN9o');
//           setStripe(stripeInstance);
//         };
//         script.onerror = () => {
//           console.error('Failed to load Stripe script');
//         };
//         document.head.appendChild(script);
//       }
//     };

//     initializeStripe();
//   }, []);

//   // Define packages data with price IDs (you'll need to get these from your Stripe dashboard)
//   const packages = [
//     {
//       id: 'platinum',
//       name: 'Platinum Membership',
//       price: 297,
//       popular: true,
//       type: 'premium',
//       stripePriceId: 'prod_RHQC49b3tbh2wj', // Replace with actual price ID from Stripe
//       image: '/platinum.avif',
//       description: 'This all-encompassing program provides fully customized fitness and nutrition plans, priority coaching, and enhanced tracking tools to guide you toward your most ambitious goals. Experience premium support, tailored entirely to your needs.',
//       features: [
//         'Individualized Training Plan UNLIMITED Days/Week - $1400/month Value',
//         'Full Access to Fitness App - $40/Month Value',
//         'UNLIMITED Text Support and Habit + Accountability Coaching - $400/Month Value',
//         'UNLIMITED Nutrition Coaching - $350/Month Value',
//         'Bi-weekly Virtual Check-ins - $300/Month Value',
//         'Mobility Assessment - $200 Value per Session',
//         'Injury/Rehab Consults - $150 Value per Session'
//       ]
//     },
//     {
//       id: 'gold',
//       name: 'Gold Membership',
//       price: 147,
//       popular: false,
//       type: 'premium',
//       stripePriceId: 'prod_RHQIHcLS7QlPit', // Replace with actual price ID from Stripe
//       image: '/gold.avif',
//       description: 'Take your fitness to the next level with the Gold Tier. Designed for those ready to commit, this plan combines personalization with accountability to ensure sustainable progress. With customized programs and ongoing support, you\'ll have the tools to achieve measurable results.',
//       features: [
//         'Individualized Training Plan 3-6 Days/Week - $1200/month Value',
//         'Full Access to Fitness App - $40/Month Value',
//         'Text Support + Accountability Coaching - $400/Month Value',
//         'Nutritional Guidance - $150/Month Value',
//         'Monthly Virtual Check-ins - $150/Month Value'
//       ]
//     },
//     {
//       id: 'silver',
//       name: 'Silver Membership',
//       price: 50,
//       popular: false,
//       type: 'basic',
//       stripePriceId: 'prod_RHQK0jMLlCaUon', // Replace with actual price ID from Stripe
//       image: '/silver.avif',
//       description: 'Start your journey with a solid foundation. The Silver Tier offers essential tools and guidance to help you achieve your fitness goals with structure and flexibility. Ideal for beginners or those looking for general guidance.',
//       features: [
//         'Individualized Training Plan 2-4 Days/Week - $800/month Value',
//         'Full Access to Fitness App - $40/Month Value',
//         'Text Support + Accountability Coaching - $400/Month Value'
//       ]
//     },
//     {
//       id: 'vip',
//       name: 'VIP Membership',
//       price: 'Custom',
//       popular: false,
//       type: 'elite',
//       stripePriceId: null, // No Stripe price for custom pricing
//       image: '/vip.avif',
//       description: 'Experience fitness at its most exclusive with the VIP Tier. This coaching experience is tailored to high-achievers seeking unmatched personalization and results. As a VIP member, you\'ll enjoy a fully immersive journey with concierge-level support, elite coaching, hybrid IN PERSON and ONLINE Training Plan along with all of the benefits of the Platinum Tier. **In-person coaching, currently limited to certain regions. Contact us for more details.',
//       features: [
//         'All Platinum Tier Benefits',
//         'In-Person Training Sessions',
//         'Priority Scheduling',
//         'Direct Access to Dr. Olu',
//         'Customized Recovery Protocols',
//         'Quarterly In-Depth Assessments',
//         'VIP Exclusive Resources'
//       ],
//       contactOnly: true
//     },
//   ];

//   // Filter packages based on active tab
//   const filteredPackages = activeTab === 'all' 
//     ? packages 
//     : packages.filter(pkg => pkg.type === activeTab);

//   const handleCheckout = async (pkg) => {
//     if (pkg.contactOnly || !pkg.stripePriceId) {
//       // Handle contact or scroll to contact section
//       const element = document.querySelector('#contact');
//       if (element) {
//         element.scrollIntoView({ behavior: 'smooth' });
//       } else {
//         // Open contact modal or show alert
//         alert('Please contact us for custom pricing on this package.');
//       }
//       return;
//     }

//     if (!stripe) {
//       console.error('Stripe has not loaded yet');
//       alert('Payment system is loading, please try again in a moment.');
//       return;
//     }

//     setLoading(prev => ({ ...prev, [pkg.id]: true }));

//     try {
//       // Method 1: Direct checkout with price ID (recommended)
//       const { error } = await stripe.redirectToCheckout({
//         lineItems: [
//           {
//             price: pkg.stripePriceId,
//             quantity: 1,
//           },
//         ],
//         mode: 'subscription',
//         successUrl: `${window.location.origin}/success?session_id={CHECKOUT_SESSION_ID}&package=${pkg.id}`,
//         cancelUrl: `${window.location.origin}/packages`,
//         clientReferenceId: pkg.id
//       });

//       if (error) {
//         console.error('Stripe checkout error:', error);
//         alert('There was an error processing your request. Please try again.');
//       }
//     } catch (error) {
//       console.error('Checkout error:', error);
//       alert('There was an error processing your request. Please try again.');
//     } finally {
//       setLoading(prev => ({ ...prev, [pkg.id]: false }));
//     }
//   };

//   // Alternative method using your backend API
//   const handleCheckoutWithAPI = async (pkg) => {
//     if (pkg.contactOnly || !pkg.stripePriceId) {
//       return;
//     }

//     if (!stripe) {
//       console.error('Stripe has not loaded yet');
//       return;
//     }

//     setLoading(prev => ({ ...prev, [pkg.id]: true }));

//     try {
//       // Call your backend to create checkout session
//       const response = await fetch('/api/create-checkout-session', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           priceId: pkg.stripePriceId,
//           packageName: pkg.name,
//           packageId: pkg.id
//         }),
//       });

//       if (!response.ok) {
//         throw new Error('Failed to create checkout session');
//       }

//       const { sessionId } = await response.json();

//       // Redirect to Stripe Checkout
//       const { error } = await stripe.redirectToCheckout({
//         sessionId: sessionId,
//       });

//       if (error) {
//         console.error('Stripe checkout error:', error);
//         alert('There was an error processing your request. Please try again.');
//       }
//     } catch (error) {
//       console.error('Checkout error:', error);
//       alert('There was an error processing your request. Please try again.');
//     } finally {
//       setLoading(prev => ({ ...prev, [pkg.id]: false }));
//     }
//   };

//   return (
//     <section className="py-16 bg-white" id="packages">
//       <div className="max-w-6xl mx-auto px-4">
//         <div className="text-center mb-16">
//           <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
//             Our <span className="text-sky-600">Membership</span> Plans
//           </h2>
//           <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//             Choose the perfect program for your fitness journey
//           </p>
//         </div>

//         <div className="flex justify-center mb-12">
//           <div className="inline-flex bg-gray-100 rounded-lg p-1">
//             <button
//               className={`px-4 py-2 rounded-md transition-colors ${activeTab === 'premium' ? 'bg-sky-600 text-white' : 'text-gray-700 hover:text-sky-600'}`}
//               onClick={() => setActiveTab('premium')}
//             >
//               Premium
//             </button>
//             <button
//               className={`px-4 py-2 rounded-md transition-colors ${activeTab === 'basic' ? 'bg-sky-600 text-white' : 'text-gray-700 hover:text-sky-600'}`}
//               onClick={() => setActiveTab('basic')}
//             >
//               Basic
//             </button>
//             <button
//               className={`px-4 py-2 rounded-md transition-colors ${activeTab === 'elite' ? 'bg-sky-600 text-white' : 'text-gray-700 hover:text-sky-600'}`}
//               onClick={() => setActiveTab('elite')}
//             >
//               Elite
//             </button>
//             <button
//               className={`px-4 py-2 rounded-md transition-colors ${activeTab === 'all' ? 'bg-sky-600 text-white' : 'text-gray-700 hover:text-sky-600'}`}
//               onClick={() => setActiveTab('all')}
//             >
//               All Plans
//             </button>
//           </div>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
//           {filteredPackages.map((pkg) => (
//             <div 
//               key={pkg.id} 
//               id={pkg.id === 'platinum' ? 'pricing-platinum' : undefined}
//               className={`relative rounded-2xl overflow-hidden transition-all duration-300 hover:shadow-xl ${
//                 pkg.popular ? 'border-2 border-yellow-400 shadow-lg' : 'border border-gray-200 shadow-sm'
//               }`}
//             >
//               {pkg.popular && (
//                 <div className="absolute top-0 left-0 right-0 bg-yellow-400 text-center py-1 text-sm font-bold z-10">
//                   Most popular
//                 </div>
//               )}
              
//               <div className={`p-6 ${pkg.popular ? 'pt-8' : ''} flex flex-col h-full`}>
//                 <div className="flex items-center gap-4 mb-4">
//                   <img 
//                     src={pkg.image} 
//                     alt={pkg.name}
//                     className="h-16 w-auto object-contain"
//                     onError={(e) => {
//                       e.target.onerror = null;
//                       e.target.src = `data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="150" height="75" viewBox="0 0 150 75"><rect width="150" height="75" fill="%23f3f4f6"/><text x="50%" y="50%" font-family="Arial" font-size="12" fill="%23374151" text-anchor="middle" dy=".3em">${pkg.name}</text></svg>`;
//                     }}
//                   />
//                   <div>
//                     <h3 className="text-2xl font-bold">{pkg.name}</h3>
//                     <div className="flex items-end">
//                       {typeof pkg.price === 'number' ? (
//                         <>
//                           <span className="text-3xl font-bold">${pkg.price}</span>
//                           <span className="text-gray-500 ml-2">per month</span>
//                           {pkg.id === 'platinum' && (
//                             <span className="text-green-600 ml-2 text-sm font-medium">+ 7 days free trial</span>
//                           )}
//                         </>
//                       ) : (
//                         <span className="text-2xl font-bold text-sky-600">{pkg.price}</span>
//                       )}
//                     </div>
//                   </div>
//                 </div>

//                 <div className="flex gap-6 flex-grow">
//                   <div className="flex-1 flex flex-col">
//                     <p className="text-gray-600 mb-4 flex-grow">
//                       {pkg.description}
//                     </p>
                    
//                     <button
//                       onClick={() => handleCheckout(pkg)}
//                       disabled={loading[pkg.id] || (!stripe && !pkg.contactOnly)}
//                       className={`w-full text-center py-3 px-6 rounded-xl font-medium transition-all duration-200 ${
//                         pkg.contactOnly 
//                           ? 'bg-white border-2 border-sky-600 text-sky-600 hover:bg-sky-50' 
//                           : pkg.id === 'platinum'
//                             ? 'bg-green-600 text-white hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed'
//                             : 'bg-sky-600 text-white hover:bg-sky-700 disabled:bg-gray-400 disabled:cursor-not-allowed'
//                       }`}
//                     >
//                       {loading[pkg.id] ? (
//                         <span className="flex items-center justify-center">
//                           <svg className="animate-spin -ml-1 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                             <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                             <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                           </svg>
//                           Processing...
//                         </span>
//                       ) : !stripe && !pkg.contactOnly ? (
//                         'Loading...'
//                       ) : pkg.contactOnly ? (
//                         'Contact us' 
//                       ) : pkg.id === 'platinum' ? (
//                         'Start Free Trial'
//                       ) : (
//                         'Subscribe'
//                       )}
//                     </button>
//                   </div>

//                   <div className="flex-1">
//                     <h4 className="font-bold mb-2">This includes:</h4>
//                     <ul className="space-y-1">
//                       {pkg.features.map((feature, index) => (
//                         <li key={index} className="flex items-start gap-2">
//                           <span className="flex-shrink-0 mt-1 text-sky-600">
//                             <Check size={16} />
//                           </span>
//                           <span className="text-gray-700 text-sm">{feature}</span>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         <div className="mt-12 text-center">
//           <p className="text-gray-500 mb-4">
//             All plans include a 7-day satisfaction guarantee. Not sure which plan is right for you?
//           </p>
//           <a
//             href="#pricing"
//             className="inline-block bg-sky-600 text-white px-8 py-3 rounded-xl hover:bg-sky-700 transition-colors"
//           >
//             Schedule a Free Consultation
//           </a>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Packages;




// //v3


// import React, { useEffect } from 'react';

// const Packages = () => {
//   useEffect(() => {
//     // Load Stripe pricing table script if not already loaded
//     if (!document.querySelector('script[src="https://js.stripe.com/v3/pricing-table.js"]')) {
//       const script = document.createElement('script');
//       script.src = 'https://js.stripe.com/v3/pricing-table.js';
//       script.async = true;
//       document.head.appendChild(script);
//     }
//   }, []);

//   return (
//     <section className="py-16 bg-white" id="packages">
//       <div className="max-w-6xl mx-auto px-4">
//         <div className="text-center mb-16">
//           <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
//             Our <span className="text-sky-600">Membership</span> Plans
//           </h2>
//           <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//             Choose the perfect program for your fitness journey
//           </p>
//         </div>

//         {/* Stripe Pricing Table */}
//         <div className="flex justify-center">
//           <stripe-pricing-table 
//             pricing-table-id="prctbl_1QOrjHEgC6ZcCDYvNApJFOgr"
//             publishable-key="pk_live_51QOqT3EgC6ZcCDYvAN6nE9DgoBXhbzWj6U6ASsg8hJt9bm3sQNehA2suTPxqBHZAvdY3e0NBt6e8sQJ913wk14lY00XuM9vN9o">
//           </stripe-pricing-table>
//         </div>

//         <div className="mt-12 text-center">
//           <p className="text-gray-500 mb-4">
//             All plans include a 7-day satisfaction guarantee. Not sure which plan is right for you?
//           </p>
//           <a
//             href="#contact"
//             className="inline-block bg-sky-600 text-white px-8 py-3 rounded-xl hover:bg-sky-700 transition-colors"
//           >
//             Schedule a Free Consultation
//           </a>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Packages;

import React, { useEffect } from 'react';

const Packages = () => {
  useEffect(() => {
    // Load Stripe pricing table script if not already loaded
    if (!document.querySelector('script[src="https://js.stripe.com/v3/pricing-table.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://js.stripe.com/v3/pricing-table.js';
      script.async = true;
      document.head.appendChild(script);
    }

    // Add custom CSS to force two-column layout
    const style = document.createElement('style');
    style.textContent = `
      stripe-pricing-table {
        --pricing-table-columns: 2 !important;
        max-width: 800px !important;
      }
      
      /* Override Stripe's default grid layout */
      stripe-pricing-table::part(pricing-table) {
        display: grid !important;
        grid-template-columns: repeat(2, 1fr) !important;
        gap: 2rem !important;
        max-width: 100% !important;
      }
      
      /* Ensure pricing cards take full width of their grid cell */
      stripe-pricing-table::part(pricing-card) {
        width: 100% !important;
        max-width: none !important;
      }
      
      /* Mobile responsiveness - stack on small screens */
      @media (max-width: 768px) {
        stripe-pricing-table::part(pricing-table) {
          grid-template-columns: 1fr !important;
        }
      }
    `;
    document.head.appendChild(style);

    // Cleanup function
    return () => {
      if (style.parentNode) {
        style.parentNode.removeChild(style);
      }
    };
  }, []);

  return (
    <section className="py-16 bg-white" id="packages">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Our <span className="text-sky-600">Membership</span> Plans
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Choose the perfect program for your fitness journey
          </p>
        </div>

        {/* Stripe Pricing Table with Custom Layout */}
        <div className="flex justify-center">
          <div className="w-full max-w-4xl">
            <stripe-pricing-table 
              pricing-table-id="prctbl_1QOrjHEgC6ZcCDYvNApJFOgr"
              publishable-key="pk_live_51QOqT3EgC6ZcCDYvAN6nE9DgoBXhbzWj6U6ASsg8hJt9bm3sQNehA2suTPxqBHZAvdY3e0NBt6e8sQJ913wk14lY00XuM9vN9o">
            </stripe-pricing-table>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-500 mb-4">
            All plans include a 7-day satisfaction guarantee. Not sure which plan is right for you?
          </p>
          <a
            href="#contact"
            className="inline-block bg-sky-600 text-white px-8 py-3 rounded-xl hover:bg-sky-700 transition-colors"
          >
            Schedule a Free Consultation
          </a>
        </div>
      </div>
    </section>
  );
};

export default Packages;